import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IEmployeeBankDetailResponse } from '../models/employee-bank-detail.model';

export const bankListFeatureKey = 'bankList';

export interface BankListState {
  loadBankListResponse: IEmployeeBankDetailResponse[];
  loadBankListFailure: any;
}

export const initialState: BankListState = {
  loadBankListResponse: undefined,
  loadBankListFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadBankListSuccess, (state, action) => ({
    ...state,
    loadBankListResponse: action.response
  })),
  on(actions.loadBankListFailure, (state, action) => ({
    ...state,
    loadBankListFailure: action.error
  }))
);

export const getBankList = (state: BankListState) => state.loadBankListResponse;
